import { TextField } from "~components";
import { translate as t, type DocWorkflowAnswerType, type KeyWithEmptyFnParam } from "~utils";

type TextAnswerProps = Extract<DocWorkflowAnswerType, { type: "TEXT" }> & {
  value?: string;
  onChange?: (value?: string) => void;
  isReadOnly?: boolean;
};

export function TextAnswer(props: TextAnswerProps) {
  const { value, onChange = () => {}, isReadOnly, placeholder } = props;
  const placeholderLabel = placeholder?.text
    ? t(placeholder.text as unknown as KeyWithEmptyFnParam)
    : undefined;

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "var(--spacing-lg)" }}>
      <TextField
        type="text"
        value={value}
        onChange={(v) => onChange(v === "" ? undefined : v)}
        isDisabled={isReadOnly}
        placeholder={placeholderLabel}
      />
    </div>
  );
}
